<div
  class="or-w-100-pc or-bg-white border-top-1-px-black or-pb-safe-bottom"
  [class.or-position-fixed]="fixedPosition()"
  [class.or-left-0]="fixedPosition()"
  [class.or-bottom-0]="fixedPosition()"
  [class.z-index-999]="fixedPosition()">
  <div class="or-d-flex or-justify-content-between">
    @for (tab of tabsData(); track tab.id) {
      <div (click)="redirect(tab.route)" [class.active]="isActive(tab.route)" class="or-w-100-pc or-pb-8-px">
        <div class="or-align-items-center or-d-flex or-flex-col or-justify-content-center or-mx-auto or-pt-8-px">
          <ion-icon
            [src]="tab.icon"
            class="or-w-24-px z-index-3 or-size-28-px or-py-4-px or-px-12-px border-radius-12"
            [ngClass]="isActive(tab.route) ? 'or-color-main-1 nav-pill-active' : 'or-color-secondary-2'"></ion-icon>
          <div
            class="z-index-3 or-text-sm or-mt-4-px"
            [ngClass]="isActive(tab.route) ? 'or-color-main-1' : 'or-color-secondary-2'">
            {{ tab.name }}
          </div>

          @if (tab.route === 'messages') {
            @if (isUnreadMessage$ | async) {
              <img
                src="assets/icons/unread-icon.svg"
                class="or-ml-28-px or-bottom-48-px or-position-absolute z-index-999" />
            }
          }
        </div>
      </div>
    }
  </div>
</div>
